import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Incident, IncidentComment } from './incident.model';
import { Page } from '../../models/page-wrapper.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IncidentService {

  private apiUrl = `${environment.restApiUrl}incidents`;

  constructor(private http: HttpClient) { }

  /**
   * Retrieves a paginated list of incidents. Supports searching and sorting.
   * @param params HttpParams for pagination, sorting, and filtering.
   * @returns An Observable of a paginated list of incidents.
   */
  getAllIncidents(params: HttpParams): Observable<Page<Incident>> {
    return this.http.get<Page<Incident>>(this.apiUrl, { params });
  }

  /**
   * Gets a single incident by its ID.
   * @param id The ID of the incident.
   * @returns An Observable of the incident.
   */
  getIncidentById(id: number): Observable<Incident> {
    return this.http.get<Incident>(`${this.apiUrl}/${id}`);
  }

  /**
   * Creates a new incident.
   * @param incident The incident data to create. The backend will assign ID and other fields.
   * @returns An Observable of the created incident.
   */
  createIncident(incident: Partial<Incident>): Observable<Incident> {
    return this.http.post<Incident>(this.apiUrl, incident);
  }

  /**
   * Updates an existing incident.
   * @param id The ID of the incident to update.
   * @param incident The updated incident data.
   * @returns An Observable of the updated incident.
   */
  updateIncident(id: number, incident: Partial<Incident>): Observable<Incident> {
    return this.http.put<Incident>(`${this.apiUrl}/${id}`, incident);
  }

  /**
   * Adds a comment to a specific incident.
   * @param incidentId The ID of the incident to add a comment to.
   * @param comment The comment data.
   * @returns An Observable of the created comment.
   */
  addComment(incidentId: number, comment: Partial<IncidentComment>): Observable<IncidentComment> {
    return this.http.post<IncidentComment>(`${this.apiUrl}/${incidentId}/comments`, comment);
  }
}